import { render, staticRenderFns } from "./registration-list.vue?vue&type=template&id=0c850d04&scoped=true&"
import script from "./registration-list.vue?vue&type=script&lang=js&"
export * from "./registration-list.vue?vue&type=script&lang=js&"
import style0 from "./registration-list.vue?vue&type=style&index=0&id=0c850d04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c850d04",
  null
  
)

export default component.exports